<div class="liberar-cita">

  <div class="card">
    <div class="card-b">
      <div class="hd">
        <mat-icon class="header-ico" aria-hidden="true">inventory_2</mat-icon>
        <div>
          <h1 class="title">Liberación de pedido</h1>
          <p class="sub">Elige qué vas a buscar y libera su pedido SAP.</p>
        </div>
      </div>

      <form (ngSubmit)="buscar()" novalidate>
        <fieldset>
          <legend class="lbl">¿Qué vas a liberar?</legend>
          <div class="modeseg">
            <label class="opt">
              <input type="radio" name="modo" value="OP" [checked]="modo === 'OP'" (change)="cambiarModo('OP')">
              <span class="box"><mat-icon aria-hidden="true">inventory_2</mat-icon><span class="nm">Orden de pedido</span></span>
            </label>
            <label class="opt">
              <input type="radio" name="modo" value="CASO" [checked]="modo === 'CASO'" (change)="cambiarModo('CASO')">
              <span class="box"><mat-icon aria-hidden="true">build</mat-icon><span class="nm">Caso postventa</span></span>
            </label>
          </div>
        </fieldset>

        <label for="campo-numero" class="lbl-numero">{{ modo === 'OP' ? 'Número de OP' : 'Número de caso' }}</label>
        <div class="sf-row">
          <div class="grow">
            <input #campoNumero type="text" id="campo-numero" name="numero" inputmode="numeric" autocomplete="off"
              [placeholder]="modo === 'OP' ? 'Ej. 4618561' : 'Ej. 01831571'" [value]="numero"
              (input)="alEscribir($any($event.target).value)"
              [class.invalid]="!!errorBusqueda" [attr.aria-invalid]="!!errorBusqueda" aria-describedby="error-numero">
            <div class="err-msg" id="error-numero" role="alert" *ngIf="errorBusqueda">{{ errorBusqueda }}</div>
          </div>
          <button class="btn btn-primary" type="submit" [disabled]="cargando">
            <mat-icon aria-hidden="true">search</mat-icon>Buscar
          </button>
        </div>
      </form>

      <div class="banner warn" role="alert" *ngIf="aviso" style="margin-top: 16px">
        <mat-icon aria-hidden="true">warning</mat-icon>
        <div>
          {{ aviso }}
          <button class="hint-btn" type="button" *ngIf="sugerirModo" (click)="irAlOtroModo()">
            Buscar en {{ sugerirModo === 'CASO' ? 'Caso postventa' : 'Orden de pedido' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div aria-live="polite">

    <div class="card" *ngIf="cargando" aria-busy="true">
      <div class="card-b skeleton-group">
        <div class="skel" style="width: 30%"></div>
        <div class="skel"></div>
        <div class="skel" style="width: 70%"></div>
      </div>
    </div>

    <div class="card" *ngIf="!cargando && !aviso && !exito && !registros.length && !caso">
      <div class="empty">
        <mat-icon class="empty-ico" aria-hidden="true">search</mat-icon>
        <h3>{{ modo === 'OP' ? 'Busca una orden de pedido' : 'Busca un caso postventa' }}</h3>
        <p>{{ modo === 'OP'
          ? 'Verás el cliente, la entrega a liberar y qué pasará al liberar.'
          : 'Verás el tipo de caso (cambio parcial, cambio total, devolución o taller), las citas y el estado de la recogida y la entrega.' }}</p>
      </div>
    </div>

    <!-- OP -->
    <div class="reveal split" *ngIf="!cargando && !exito && modo === 'OP' && registroVisible as r">
      <aside class="card aside" aria-label="Resumen de la OP">
        <div class="card-b">
          <div class="sum">
            <h2 class="rh">OP <span class="num">{{ opConsultada }}</span></h2>
            <span class="tipo" *ngIf="entregasParciales">Entregas parciales</span>
            <span class="chip" *ngIf="!entregasParciales" [ngClass]="'chip-' + etiquetaOp(r).clase">{{ etiquetaOp(r).texto }}</span>
          </div>
          <dl class="kv">
            <div><dt>Cliente</dt><dd>{{ r.nombres }}</dd></div>
            <div><dt>Agencia</dt><dd>{{ r.tienda }}</dd></div>
            <div><dt>Cita de entrega</dt><dd class="num">{{ r.fecha_cita_entrega || '—' }}</dd></div>
          </dl>
          <details class="more">
            <summary>Ver más datos</summary>
            <dl class="kv">
              <div><dt>Identificación</dt><dd class="num">{{ r.identificacion }}</dd></div>
              <div><dt>Destino</dt><dd>{{ r.destino }}</dd></div>
              <div><dt>Fecha picking</dt><dd class="num">{{ r.fecha_picking || '—' }}</dd></div>
            </dl>
          </details>
        </div>
      </aside>

      <section class="card">
        <div class="card-h">
          <mat-icon class="header-ico" aria-hidden="true">event_available</mat-icon>
          <h2 class="sec-title">Liberar pedido</h2>
        </div>
        <div class="card-b">
          <app-formulario-liberacion
            [motivos]="motivos" [topCausales]="topCausales" [diasTop]="diasTop" [pais]="pais" [cargandoCausales]="cargandoCausales" [errorCausales]="errorCausales" [filasRevision]="filasRevision" [consecuencias]="consecuencias"
            [seleccionValida]="!!seleccionado" [enviando]="enviando"
            (seleccionFaltante)="alFaltarSeleccion()" (confirmar)="confirmar($event)">

            <fieldset class="fld">
              <legend class="lbl">{{ entregasParciales ? '¿Qué entrega quieres liberar?' : 'Pedido SAP a liberar' }}</legend>
              <div class="picks" id="picks-entrega">
                <label class="pick" *ngFor="let reg of registros; let i = index">
                  <input type="radio" name="registroOp" [value]="reg.id" [checked]="seleccionado === reg" (change)="seleccionarRegistro(reg)">
                  <span class="pbox">
                    <span class="prole">{{ rolEntrega(i) }}</span>
                    <span class="psap num">{{ reg.num_pedido_sap ? 'SAP ' + reg.num_pedido_sap : 'Pedido SAP de la OP' }}</span>
                    <span class="chip" [ngClass]="'chip-' + etiquetaOp(reg).clase">{{ etiquetaOp(reg).texto }}</span>
                    <span class="psap" *ngIf="entregasParciales && reg.fecha_cita_entrega">Cita {{ reg.fecha_cita_entrega }}</span>
                  </span>
                </label>
              </div>
              <div class="err-msg" role="alert" *ngIf="mostrarErrorSeleccion && !seleccionado">Elige la entrega que quieres liberar.</div>
            </fieldset>

            <div class="dyn"><app-que-pasara [lineas]="consecuencias"></app-que-pasara></div>
          </app-formulario-liberacion>
        </div>
      </section>
    </div>

    <!-- Caso -->
    <div class="reveal split" *ngIf="!cargando && !exito && modo === 'CASO' && caso as c">
      <aside class="card aside" aria-label="Resumen del caso">
        <div class="card-b">
          <div class="sum">
            <h2 class="rh">Caso <span class="num">{{ c.num_caso }}</span></h2>
            <span class="tipo">{{ c.tipo_descripcion }}</span>
          </div>
          <dl class="kv">
            <div><dt>Cliente</dt><dd>{{ c.nombres }}</dd></div>
            <div><dt>Agencia</dt><dd>{{ c.tienda }}</dd></div>
            <div><dt>Cita de desarme / empaque</dt><dd class="num">{{ c.cita_empaque || '—' }}</dd></div>
            <div><dt>Cita de recogida</dt><dd class="num">{{ c.cita_recogida || '—' }}</dd></div>
            <div><dt>Cita de entrega</dt><dd class="num">{{ c.cita_entrega || '—' }}</dd></div>
            <div><dt>Cita de armado</dt><dd class="num">{{ c.cita_armado || '—' }}</dd></div>
          </dl>
          <details class="more">
            <summary>Ver más datos</summary>
            <dl class="kv">
              <div><dt>Identificación</dt><dd class="num">{{ c.identificacion }}</dd></div>
              <div><dt>Destino</dt><dd>{{ c.destino }}</dd></div>
            </dl>
          </details>
        </div>
      </aside>

      <section class="card">
        <div class="card-h">
          <mat-icon class="header-ico" aria-hidden="true">event_available</mat-icon>
          <h2 class="sec-title">Liberar pedido</h2>
        </div>
        <div class="card-b">

          <ng-template #pedidosSap>
            <div class="fld">
              <span class="lbl2" id="lbl-pedidos-caso">Pedidos SAP del caso</span>
              <div class="lados" role="list" aria-labelledby="lbl-pedidos-caso">
                <div class="lado" role="listitem" *ngFor="let f of filasPedidos" [class.dim]="f.hecho">
                  <span class="prole">{{ f.rol }}</span>
                  <span class="psap num">{{ f.sap ? 'SAP ' + f.sap : 'Sin pedido SAP' }}</span>
                  <span class="chip" [ngClass]="'chip-' + f.estado.clase">{{ f.estado.texto }}</span>
                </div>
              </div>
            </div>
          </ng-template>

          <app-formulario-liberacion *ngIf="c.estado_global === 'liberable'"
            [motivos]="motivos" [topCausales]="topCausales" [diasTop]="diasTop" [pais]="pais" [cargandoCausales]="cargandoCausales" [errorCausales]="errorCausales" [filasRevision]="filasRevision" [consecuencias]="consecuencias" [enviando]="enviando"
            (confirmar)="confirmar($event)">
            <ng-container *ngTemplateOutlet="pedidosSap"></ng-container>
            <div class="dyn"><app-que-pasara [lineas]="consecuencias"></app-que-pasara></div>
          </app-formulario-liberacion>

          <ng-container *ngIf="c.estado_global !== 'liberable'">
            <ng-container *ngTemplateOutlet="pedidosSap"></ng-container>
            <div class="banner warn" role="alert" style="margin-top: 16px" *ngIf="c.estado_global === 'bloqueado'">
              <mat-icon aria-hidden="true">warning</mat-icon>
              <div><b>Este caso no se puede liberar ahora.</b> {{ motivoBloqueo }}</div>
            </div>
            <div class="banner info" role="status" style="margin-top: 16px" *ngIf="c.estado_global === 'nada_que_liberar'">
              <mat-icon aria-hidden="true">info</mat-icon>
              <div><b>No hay nada que liberar en este caso.</b> Los pedidos SAP ya están liberados o finalizados.</div>
            </div>
          </ng-container>

        </div>
      </section>
    </div>

    <!-- Éxito -->
    <div class="card" *ngIf="exito as e">
      <div class="success" role="status">
        <span class="ok-ring"><mat-icon aria-hidden="true">check</mat-icon></span>
        <h2>¡Listo!</h2>
        <p>{{ e.mensaje }}</p>
        <ul class="exito-detalles" *ngIf="e.detalles.length">
          <li *ngFor="let d of e.detalles">{{ d }}</li>
        </ul>
        <div class="banner warn" role="alert" *ngIf="e.advertencia">
          <mat-icon aria-hidden="true">warning</mat-icon>
          <div>{{ e.advertencia }}</div>
        </div>
        <button class="btn btn-primary" type="button" (click)="gestionarOtro()">Gestionar otro</button>
      </div>
    </div>

  </div>
</div>
